import { render, staticRenderFns } from "./ContactFavoriteButton.vue?vue&type=template&id=562c8842&"
import script from "./ContactFavoriteButton.vue?vue&type=script&lang=ts&"
export * from "./ContactFavoriteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/builds/quebec-solidaire/qs_pointage_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('562c8842')) {
      api.createRecord('562c8842', component.options)
    } else {
      api.reload('562c8842', component.options)
    }
    module.hot.accept("./ContactFavoriteButton.vue?vue&type=template&id=562c8842&", function () {
      api.rerender('562c8842', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Contact/ContactFavoriteButton.vue"
export default component.exports